module.exports = __webpack_public_path__ + "img/save.5788b3f1.svg";